export default __webpack_public_path__ + "static/media/circle-plus.f73ff2e7.svg";